import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IOrderTemplateRepository } from '@/coreInfrastructureModule/interfaces/IOrderTemplateRepository';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { OrderTemplateDetailEntity } from '../domains/entities/orderTemplate';
import { OrderTemplateAdapter } from '../adapters/orderTemplateAdapter';
import { OrderTemplateUpsertRequest } from '@/coreInfrastructureModule/axios/generated/orderManage/api';

/**
 * 発注テンプレートを登録するユースケース
 */
export class CreateOrderTemplateUseCase {
  /**
   * コンストラクタ
   * @param repository - 発注テンプレートを登録するリポジトリ
   */
  constructor(private readonly repository: IOrderTemplateRepository) {}

  /**
   * テンプレートを登録する
   * @param request - 登録内容
   */
  public Execute = async (request: OrderTemplateUpsertRequest): Promise<INetworkResult<OrderTemplateDetailEntity, IError>> => {
    const result = await this.repository.create(request);
    if (result.status.type === 'success') {
      return {
        status: {
          type: 'success',
          data: OrderTemplateAdapter.toDetailEntity(result.status.data),
        },
      };
    }

    return { status: result.status };
  };
}
